// 導航欄翻譯

export const navbar = {
    home: '首頁',
    aiWorkbench: 'AI工作台',
    mvGeneration: '音樂生成',
    myCreations: '我的創作',
    pricing: '定價',
    showcase: '展示',
    profile: '個人資料',
    logout: '登出',
    signIn: '登入'
  };
